import {useDialog} from '@soop-ui/soop-ui';
import {useEffect} from 'react';

// dialog가 전역이라 페이지를 이동해도 레이어가 닫히지 않는다
// 페이지를 이동할 때 레이어를 닫는 훅 임시로 작성
export const useAutoCloseDialog = () => {
  const {openDialog, closeDialog} = useDialog();

  useEffect(() => {
    return () => closeDialog(true);
  }, [closeDialog]);

  return {openDialog, closeDialog};
};
